<template>
  <v-card tile style="background-color: #F5F5F5;">
    <v-toolbar flat dark color="#01579B">
      <v-btn icon dark @click="closeDocModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Documents</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-subheader>Original Document</v-subheader>
      </v-list>

      <v-row>
        <v-col cols="12" md="6">
          <embed :src="url + singleDoc.file_name" width="100%" height="100%" />
        </v-col>

        <v-col cols="12" md="6" class="p-4">
          <v-chip
            style="float:right"
            class="ma-2"
            color="green"
            text-color="white"
          >
            Last Updated:
            {{ formatDate(singleDoc.updated_at) }}
          </v-chip>

          <h1 class="display-1">
            Edit document (Preview)
          </h1>

          <v-divider></v-divider>

          <!-- This example requires Tailwind CSS v2.0+ -->
          <div v-if="showAlert" class="rounded-md bg-yellow-50 p-4 mt-2">
            <div class="flex">
              <div class="flex-shrink-0">
                <!-- Heroicon name: solid/exclamation -->
                <svg
                  class="h-5 w-5 text-yellow-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-bold text-yellow-800">
                  Attention
                </h3>
                <div class="mt-2 text-sm text-yellow-700">
                  <p>
                    Updating Documents changes the formatting below so that
                    checkbox options are grouped under the input fields. Scroll
                    down to update checkbox options.
                  </p>
                </div>
              </div>

              <div class="ml-auto pl-3">
                <div class="-mx-1.5 -my-1.5">
                  <button
                    @click="showAlert = !showAlert"
                    type="button"
                    class="inline-flex bg-yellow-400 rounded-md p-1.5 text-orange-50 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-orange-600"
                  >
                    <span class="sr-only">Dismiss</span>
                    <!-- Heroicon name: solid/x -->
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="mt-4">
              <button
                @click="showAlert = !showAlert"
                type="button"
                class="inline-flex bg-yellow-400 rounded-md p-1 text-orange-50 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-orange-600"
              >
                Show Message
              </button>
            </div>
          </div>

          <template v-if="singleDoc.updates">
            <div class="mt-4 row p-2">
              <b>Notes</b>
              <div class="col-md-12">
                <div v-for="message in singleDoc.updates" :key="message.id">
                  <v-alert border="top" colored-border type="info">
                    <b>From:</b>
                    {{ message.user_name }} <br />
                    <b>Notes:</b>
                    {{ message.changes_notes }}
                  </v-alert>
                </div>
              </div>
            </div>
          </template>

          <template
            v-if="!singleDoc.json_data || singleDoc.json_data == 'false'"
          ></template>

          <template v-else>
            <v-form id="myForm">
              <div class="form-group">
                <div
                  class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                >
                  <div
                    v-for="single in JSON.parse(singleDoc.json_data)"
                    :key="single.id"
                    class="sm:col-span-3"
                  >
                    <div v-if="single.box" class="mt-1">
                      <label
                        for="first_name"
                        class="block text-sm font-medium text-indigo-600"
                      >
                        {{ single.name }}
                      </label>

                      <input
                        class="disabled:opacity-50 focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border border-gray-300 rounded-md p-2"
                        type="checkbox"
                        :name="single.name"
                        :checked="single.value == 'Yes' ? true : false"
                        :value="single.value"
                        :id="single.name"
                        :disabled="singleDoc.disabled == 1"
                      />
                    </div>

                    <div v-else class="mt-1">
                      <label
                        for="first_name"
                        class="block text-sm font-medium text-gray-700"
                      >
                        {{ single.name }}
                      </label>

                      <input
                        type="text"
                        :disabled="singleDoc.disabled == 1"
                        :name="single.name"
                        :value="single.value"
                        class="disabled:opacity-50 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md p-2"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <v-btn
                :disabled="singleDoc.disabled == 1"
                rounded
                type="submit"
                @click.prevent="updateSubmission(singleDoc)"
                small
                class="text-white"
                color="#0D47A1"
              >
                Save Changes
              </v-btn>
            </v-form>
          </template>
        </v-col>
      </v-row>
    </v-card-text>

    <div style="flex: 1 1 auto;"></div>
  </v-card>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
import moment from "moment";

export default {
  props: ["singleDoc"],
  data() {
    return {
      showAlert: true,
      url: process.env.VUE_APP_API_URL_FILES,
      url2: process.env.VUE_APP_API_URL_S3
    };
  },

  methods: {
    formatDate(date) {
      let newDate = moment.utc(date).format("MMMM Do YYYY");
      return (this.dataModal = newDate);
    },

    updateSubmission(singleDoc) {
      var queryString = $("#myForm input:text").serializeArray(); // store json object

      $("#myForm input:checkbox").each(function(i, e) {
        queryString.push({
          name: e.name,
          value: e.checked ? "Yes" : "Off",
          box: true
        });
      });

      window.axios
        .post("/api/updateSubmission/" + singleDoc.id, {
          queryString: queryString
        })
        .then(() => {
          this.dialog = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Form data succesfully sent, Waiting for aprove",
            showConfirmButton: false,
            timer: 1500
          });
          this.$emit("updated");
        });
    },

    closeDocModal() {
      this.$emit("clicked");
    }
  }
};
</script>
